import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  Stack,
} from '@mui/material';
import EmailCampaignStatusChip from './EmailCampaignStatusChip';

export default function EmailCampaignDeliveriesTable({
  rows = [],
  loading = false,
  page = 1,
  perPage = 25,
  total = 0,
  onPageChange,
  onPerPageChange,
}) {
  const pageIndex = Math.max(0, Number(page || 1) - 1);

  return (
    <Paper variant="outlined">
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Employee</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Error</TableCell>
              <TableCell>Queued</TableCell>
              <TableCell>Sent</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7}>
                  <Typography variant="body2" color="text.secondary">
                    No deliveries found.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : null}

            {rows.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>
                  <Stack spacing={0.25}>
                    <Typography variant="body2">{row.employee?.name || row.to_name || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {row.employee?.employee_code || '-'}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>{row.to_email}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>
                  <EmailCampaignStatusChip status={row.status} />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color={row.error ? 'error.main' : 'text.secondary'}>
                    {row.error || '-'}
                  </Typography>
                </TableCell>
                <TableCell>{row.queued_at ? new Date(row.queued_at).toLocaleString() : '-'}</TableCell>
                <TableCell>{row.sent_at ? new Date(row.sent_at).toLocaleString() : '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={Number(total || 0)}
        page={pageIndex}
        onPageChange={(_, nextPage) => onPageChange?.(nextPage + 1)}
        rowsPerPage={Number(perPage || 25)}
        onRowsPerPageChange={(event) => onPerPageChange?.(Number(event.target.value || 25))}
        rowsPerPageOptions={[10, 25, 50, 100]}
      />
    </Paper>
  );
}
